import { Injectable } from '@angular/core';
import { SharedServices } from '../services/shared.services';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private baseUrl = environment.apiUrl;

  constructor(private sharedService: SharedServices, private http: HttpClient) {}

  fetchUserRoles(): Observable<string[]> {  
    const loggedUserEmail = this.sharedService.getloggedUserEmail();
    return this.http.get<string[]>(`${this.baseUrl}/ReferenceData/GetAccessTypes?email=${loggedUserEmail}`);
  }

  hasRole(expectedRoles: string[]): Observable<boolean> {
    return this.fetchUserRoles().pipe(
      map((roles: string[]) => {
        if (!roles || roles.length === 0) {
          // No roles found, return false
          return false;
        }
        return expectedRoles.some(role => roles.map(r => r.trim()).includes(role));
      }),
      // Handle errors gracefully and return false
      catchError(() => of(false))
    );
  }
}
